import React, { useState, useEffect } from "react";
import LabelValueRow from "../../LabelValueRow";

const ImposteWidget = ({
  contributiTotali,
  riduzioneImposte,
  setimposteTotali,
  imposteTotali,
  redditoPrevidenziale,
}) => {
  const [imposta, setImposta] = useState(15);

  useEffect(() => {
    if (riduzioneImposte === "1") {
      setImposta(5);
    } else {
      setImposta(15);
    }
  }, [riduzioneImposte]);

  useEffect(() => {
    setimposteTotali(
      (redditoPrevidenziale - contributiTotali) * (imposta / 100)
    );
  }, [redditoPrevidenziale, contributiTotali, imposta, setimposteTotali]);

  return (
    <div>
      <LabelValueRow
        label={"Reddito imponibile fiscale"}
        value={redditoPrevidenziale - contributiTotali}
        tooltipText={
          "Calcolato considerando come già versati i contributi dedotti dall’imponibile"
        }
      />
      <LabelValueRow
        label={"Imposta"}
        meta={`${imposta}%`}
        value={`${imposteTotali}`}
        important={true}
      />
    </div>
  );
};

export default ImposteWidget;
